import { useMutation } from '@tanstack/react-query';

import type { EditCompanyClientsPayload } from '@/api/v4/organization.api';
import { editCompanyClients } from '@/api/v4/organization.api';
import { queryClient, QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';
import { companyIdState } from '../company.state';
import { useCompanyFetchMode } from '../company-fetch-context';
import { useAtomValue } from 'jotai';

export const useEditCompanyClients = () => {
  const { t } = useTranslation('default');
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  return useMutation({
    mutationFn: async (clients: EditCompanyClientsPayload['clients']) =>
      companyId ? editCompanyClients(companyId, { clients }) : undefined,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyClients, fetchMode, companyId],
      });
    },
    onError: () => {
      notify({
        message: t`default:unknownError`,
      });
    },
  });
};
